import {TRACKING} from '../getTrackingData'
import {store} from '../../../app/store'
import {RootState} from '../../../app/rootReducer'

export function getFormName(isShowroom: boolean, isOverview: boolean): string {
    const base = isShowroom
        ? `${TRACKING.FORM_NAME} - ${TRACKING.FORM_NAME_SHOWROOM}`
        : `${TRACKING.FORM_NAME} - ${
              isOverview
                  ? TRACKING.FORM_NAME_OVERVIEW
                  : TRACKING.FORM_NAME_MODEL
          }`

    const state = store.getState() as RootState
    const isAuto = state.userData.autoloadedRFQForm

    return isAuto ? `${base} - ${TRACKING.FORM_NAME_AUTO}` : base
}
